// ../../node_modules/.pnpm/preact@10.17.1/node_modules/preact/dist/preact.mjs
var n;
var l;
var u;
var t;
var i;
var o;
var r;
var f;
var e;
var c = {};
var s = [];
var a = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
var h = Array.isArray;
function v(n2, l3) {
  for (var u3 in l3)
    n2[u3] = l3[u3];
  return n2;
}
function p(n2) {
  var l3 = n2.parentNode;
  l3 && l3.removeChild(n2);
}
function y(l3, u3, t3) {
  var i3, o3, r3, f3 = {};
  for (r3 in u3)
    "key" == r3 ? i3 = u3[r3] : "ref" == r3 ? o3 = u3[r3] : f3[r3] = u3[r3];
  if (arguments.length > 2 && (f3.children = arguments.length > 3 ? n.call(arguments, 2) : t3), "function" == typeof l3 && null != l3.defaultProps)
    for (r3 in l3.defaultProps)
      void 0 === f3[r3] && (f3[r3] = l3.defaultProps[r3]);
  return d(l3, f3, i3, o3, null);
}
function d(n2, t3, i3, o3, r3) {
  var f3 = { type: n2, props: t3, key: i3, ref: o3, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, __h: null, constructor: void 0, __v: null == r3 ? ++u : r3 };
  return null == r3 && null != l.vnode && l.vnode(f3), f3;
}
function k(n2) {
  return n2.children;
}
function b(n2, l3) {
  this.props = n2, this.context = l3;
}
function g(n2, l3) {
  if (null == l3)
    return n2.__ ? g(n2.__, n2.__.__k.indexOf(n2) + 1) : null;
  for (var u3; l3 < n2.__k.length; l3++)
    if (null != (u3 = n2.__k[l3]) && null != u3.__e)
      return u3.__e;
  return "function" == typeof n2.type ? g(n2) : null;
}
function m(n2) {
  var l3, u3;
  if (null != (n2 = n2.__) && null != n2.__c) {
    for (n2.__e = n2.__c.base = null, l3 = 0; l3 < n2.__k.length; l3++)
      if (null != (u3 = n2.__k[l3]) && null != u3.__e) {
        n2.__e = n2.__c.base = u3.__e;
        break;
      }
    return m(n2);
  }
}
function w(n2) {
  (!n2.__d && (n2.__d = true) && i.push(n2) && !x.__r++ || o !== l.debounceRendering) && ((o = l.debounceRendering) || r)(x);
}
function x() {
  var n2, l3, u3, t3, o3, r3, e3, c3, s3;
  for (i.sort(f); n2 = i.shift(); )
    n2.__d && (l3 = i.length, t3 = void 0, o3 = void 0, r3 = void 0, c3 = (e3 = (u3 = n2).__v).__e, (s3 = u3.__P) && (t3 = [], o3 = [], (r3 = v({}, e3)).__v = e3.__v + 1, L(s3, e3, r3, u3.__n, void 0 !== s3.ownerSVGElement, null != e3.__h ? [c3] : null, t3, null == c3 ? g(e3) : c3, e3.__h, o3), M(t3, e3, o3), e3.__e != c3 && m(e3)), i.length > l3 && i.sort(f));
  x.__r = 0;
}
function P(n2, l3, u3, t3, i3, o3, r3, f3, e3, a3, v3) {
  var p3, y2, _, b3, m3, w3, x2, P2, C, H2 = 0, I2 = t3 && t3.__k || s, T2 = I2.length, j3 = T2, z3 = l3.length;
  for (u3.__k = [], p3 = 0; p3 < z3; p3++)
    null != (b3 = u3.__k[p3] = null == (b3 = l3[p3]) || "boolean" == typeof b3 || "function" == typeof b3 ? null : "string" == typeof b3 || "number" == typeof b3 || "bigint" == typeof b3 ? d(null, b3, null, null, b3) : h(b3) ? d(k, { children: b3 }, null, null, null) : b3.__b > 0 ? d(b3.type, b3.props, b3.key, b3.ref ? b3.ref : null, b3.__v) : b3) ? (b3.__ = u3, b3.__b = u3.__b + 1, -1 === (P2 = A(b3, I2, x2 = p3 + H2, j3)) ? _ = c : (_ = I2[P2] || c, I2[P2] = void 0, j3--), L(n2, b3, _, i3, o3, r3, f3, e3, a3, v3), m3 = b3.__e, (y2 = b3.ref) && _.ref != y2 && (_.ref && O(_.ref, null, b3), v3.push(y2, b3.__c || m3, b3)), null != m3 && (null == w3 && (w3 = m3), (C = _ === c || null === _.__v) ? -1 == P2 && H2-- : P2 !== x2 && (P2 === x2 + 1 ? H2++ : P2 > x2 ? j3 > z3 - x2 ? H2 += P2 - x2 : H2-- : H2 = P2 < x2 && P2 == x2 - 1 ? P2 - x2 : 0), x2 = p3 + H2, "function" != typeof b3.type || P2 === x2 && _.__k !== b3.__k ? "function" == typeof b3.type || P2 === x2 && !C ? void 0 !== b3.__d ? (e3 = b3.__d, b3.__d = void 0) : e3 = m3.nextSibling : e3 = S(n2, m3, e3) : e3 = $(b3, e3, n2), "function" == typeof u3.type && (u3.__d = e3))) : (_ = I2[p3]) && null == _.key && _.__e && (_.__e == e3 && (e3 = g(_)), q(_, _, false), I2[p3] = null);
  for (u3.__e = w3, p3 = T2; p3--; )
    null != I2[p3] && ("function" == typeof u3.type && null != I2[p3].__e && I2[p3].__e == u3.__d && (u3.__d = I2[p3].__e.nextSibling), q(I2[p3], I2[p3]));
}
function $(n2, l3, u3) {
  for (var t3, i3 = n2.__k, o3 = 0; i3 && o3 < i3.length; o3++)
    (t3 = i3[o3]) && (t3.__ = n2, l3 = "function" == typeof t3.type ? $(t3, l3, u3) : S(u3, t3.__e, l3));
  return l3;
}
function S(n2, l3, u3) {
  return null == u3 || u3.parentNode !== n2 ? n2.insertBefore(l3, null) : l3 == u3 && null != l3.parentNode || n2.insertBefore(l3, u3), l3.nextSibling;
}
function A(n2, l3, u3, t3) {
  var i3 = n2.key, o3 = n2.type, r3 = u3 - 1, f3 = u3 + 1, e3 = l3[u3];
  if (null === e3 || e3 && i3 == e3.key && o3 === e3.type)
    return u3;
  if (t3 > (null != e3 ? 1 : 0))
    for (; r3 >= 0 || f3 < l3.length; ) {
      if (r3 >= 0) {
        if ((e3 = l3[r3]) && i3 == e3.key && o3 === e3.type)
          return r3;
        r3--;
      }
      if (f3 < l3.length) {
        if ((e3 = l3[f3]) && i3 == e3.key && o3 === e3.type)
          return f3;
        f3++;
      }
    }
  return -1;
}
function H(n2, l3, u3, t3, i3) {
  var o3;
  for (o3 in u3)
    "children" === o3 || "key" === o3 || o3 in l3 || T(n2, o3, null, u3[o3], t3);
  for (o3 in l3)
    i3 && "function" != typeof l3[o3] || "children" === o3 || "key" === o3 || "value" === o3 || "checked" === o3 || u3[o3] === l3[o3] || T(n2, o3, l3[o3], u3[o3], t3);
}
function I(n2, l3, u3) {
  "-" === l3[0] ? n2.setProperty(l3, null == u3 ? "" : u3) : n2[l3] = null == u3 ? "" : "number" != typeof u3 || a.test(l3) ? u3 : u3 + "px";
}
function T(n2, l3, u3, t3, i3) {
  var o3;
  n:
    if ("style" === l3)
      if ("string" == typeof u3)
        n2.style.cssText = u3;
      else {
        if ("string" == typeof t3 && (n2.style.cssText = t3 = ""), t3)
          for (l3 in t3)
            u3 && l3 in u3 || I(n2.style, l3, "");
        if (u3)
          for (l3 in u3)
            t3 && u3[l3] === t3[l3] || I(n2.style, l3, u3[l3]);
      }
    else if ("o" === l3[0] && "n" === l3[1])
      o3 = l3 !== (l3 = l3.replace(/(PointerCapture)$|Capture$/, "$1")), l3 = l3.toLowerCase() in n2 ? l3.toLowerCase().slice(2) : l3.slice(2), n2.l || (n2.l = {}), n2.l[l3 + o3] = u3, u3 ? t3 || n2.addEventListener(l3, o3 ? z : j, o3) : n2.removeEventListener(l3, o3 ? z : j, o3);
    else if ("dangerouslySetInnerHTML" !== l3) {
      if (i3)
        l3 = l3.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
      else if ("width" !== l3 && "height" !== l3 && "href" !== l3 && "list" !== l3 && "form" !== l3 && "tabIndex" !== l3 && "download" !== l3 && "rowSpan" !== l3 && "colSpan" !== l3 && l3 in n2)
        try {
          n2[l3] = null == u3 ? "" : u3;
          break n;
        } catch (n3) {
        }
      "function" == typeof u3 || (null == u3 || false === u3 && "-" !== l3[4] ? n2.removeAttribute(l3) : n2.setAttribute(l3, u3));
    }
}
function j(n2) {
  return this.l[n2.type + false](l.event ? l.event(n2) : n2);
}
function z(n2) {
  return this.l[n2.type + true](l.event ? l.event(n2) : n2);
}
function L(n2, u3, t3, i3, o3, r3, f3, e3, c3, s3) {
  var a3, p3, y2, d3, _, g3, m3, w3, x2, $2, C, S2, A2, H2, I2, T2 = u3.type;
  if (void 0 !== u3.constructor)
    return null;
  null != t3.__h && (c3 = t3.__h, e3 = u3.__e = t3.__e, u3.__h = null, r3 = [e3]), (a3 = l.__b) && a3(u3);
  n:
    if ("function" == typeof T2)
      try {
        if (w3 = u3.props, x2 = (a3 = T2.contextType) && i3[a3.__c], $2 = a3 ? x2 ? x2.props.value : a3.__ : i3, t3.__c ? m3 = (p3 = u3.__c = t3.__c).__ = p3.__E : ("prototype" in T2 && T2.prototype.render ? u3.__c = p3 = new T2(w3, $2) : (u3.__c = p3 = new b(w3, $2), p3.constructor = T2, p3.render = B), x2 && x2.sub(p3), p3.props = w3, p3.state || (p3.state = {}), p3.context = $2, p3.__n = i3, y2 = p3.__d = true, p3.__h = [], p3._sb = []), null == p3.__s && (p3.__s = p3.state), null != T2.getDerivedStateFromProps && (p3.__s == p3.state && (p3.__s = v({}, p3.__s)), v(p3.__s, T2.getDerivedStateFromProps(w3, p3.__s))), d3 = p3.props, _ = p3.state, p3.__v = u3, y2)
          null == T2.getDerivedStateFromProps && null != p3.componentWillMount && p3.componentWillMount(), null != p3.componentDidMount && p3.__h.push(p3.componentDidMount);
        else {
          if (null == T2.getDerivedStateFromProps && w3 !== d3 && null != p3.componentWillReceiveProps && p3.componentWillReceiveProps(w3, $2), !p3.__e && (null != p3.shouldComponentUpdate && false === p3.shouldComponentUpdate(w3, p3.__s, $2) || u3.__v === t3.__v)) {
            for (u3.__v !== t3.__v && (p3.props = w3, p3.state = p3.__s, p3.__d = false), u3.__e = t3.__e, u3.__k = t3.__k, u3.__k.forEach(function(n3) {
              n3 && (n3.__ = u3);
            }), C = 0; C < p3._sb.length; C++)
              p3.__h.push(p3._sb[C]);
            p3._sb = [], p3.__h.length && f3.push(p3);
            break n;
          }
          null != p3.componentWillUpdate && p3.componentWillUpdate(w3, p3.__s, $2), null != p3.componentDidUpdate && p3.__h.push(function() {
            p3.componentDidUpdate(d3, _, g3);
          });
        }
        if (p3.context = $2, p3.props = w3, p3.__P = n2, p3.__e = false, S2 = l.__r, A2 = 0, "prototype" in T2 && T2.prototype.render) {
          for (p3.state = p3.__s, p3.__d = false, S2 && S2(u3), a3 = p3.render(p3.props, p3.state, p3.context), H2 = 0; H2 < p3._sb.length; H2++)
            p3.__h.push(p3._sb[H2]);
          p3._sb = [];
        } else
          do {
            p3.__d = false, S2 && S2(u3), a3 = p3.render(p3.props, p3.state, p3.context), p3.state = p3.__s;
          } while (p3.__d && ++A2 < 25);
        p3.state = p3.__s, null != p3.getChildContext && (i3 = v(v({}, i3), p3.getChildContext())), y2 || null == p3.getSnapshotBeforeUpdate || (g3 = p3.getSnapshotBeforeUpdate(d3, _)), P(n2, h(I2 = null != a3 && a3.type === k && null == a3.key ? a3.props.children : a3) ? I2 : [I2], u3, t3, i3, o3, r3, f3, e3, c3, s3), p3.base = u3.__e, u3.__h = null, p3.__h.length && f3.push(p3), m3 && (p3.__E = p3.__ = null);
      } catch (n3) {
        u3.__v = null, (c3 || null != r3) && (u3.__e = e3, u3.__h = !!c3, r3[r3.indexOf(e3)] = null), l.__e(n3, u3, t3);
      }
    else
      null == r3 && u3.__v === t3.__v ? (u3.__k = t3.__k, u3.__e = t3.__e) : u3.__e = N(t3.__e, u3, t3, i3, o3, r3, f3, c3, s3);
  (a3 = l.diffed) && a3(u3);
}
function M(n2, u3, t3) {
  for (var i3 = 0; i3 < t3.length; i3++)
    O(t3[i3], t3[++i3], t3[++i3]);
  l.__c && l.__c(u3, n2), n2.some(function(u4) {
    try {
      n2 = u4.__h, u4.__h = [], n2.some(function(n3) {
        n3.call(u4);
      });
    } catch (n3) {
      l.__e(n3, u4.__v);
    }
  });
}
function N(l3, u3, t3, i3, o3, r3, f3, e3, s3) {
  var a3, v3, y2, d3 = t3.props, _ = u3.props, k3 = u3.type, b3 = 0;
  if ("svg" === k3 && (o3 = true), null != r3) {
    for (; b3 < r3.length; b3++)
      if ((a3 = r3[b3]) && "setAttribute" in a3 == !!k3 && (k3 ? a3.localName === k3 : 3 === a3.nodeType)) {
        l3 = a3, r3[b3] = null;
        break;
      }
  }
  if (null == l3) {
    if (null === k3)
      return document.createTextNode(_);
    l3 = o3 ? document.createElementNS("http://www.w3.org/2000/svg", k3) : document.createElement(k3, _.is && _), r3 = null, e3 = false;
  }
  if (null === k3)
    d3 === _ || e3 && l3.data === _ || (l3.data = _);
  else {
    if (r3 = r3 && n.call(l3.childNodes), v3 = (d3 = t3.props || c).dangerouslySetInnerHTML, y2 = _.dangerouslySetInnerHTML, !e3) {
      if (null != r3)
        for (d3 = {}, b3 = 0; b3 < l3.attributes.length; b3++)
          d3[l3.attributes[b3].name] = l3.attributes[b3].value;
      (y2 || v3) && (y2 && (v3 && y2.__html == v3.__html || y2.__html === l3.innerHTML) || (l3.innerHTML = y2 && y2.__html || ""));
    }
    if (H(l3, _, d3, o3, e3), y2)
      u3.__k = [];
    else if (P(l3, h(b3 = u3.props.children) ? b3 : [b3], u3, t3, i3, o3 && "foreignObject" !== k3, r3, f3, r3 ? r3[0] : t3.__k && g(t3, 0), e3, s3), null != r3)
      for (b3 = r3.length; b3--; )
        null != r3[b3] && p(r3[b3]);
    e3 || ("value" in _ && void 0 !== (b3 = _.value) && (b3 !== l3.value || "progress" === k3 && !b3 || "option" === k3 && b3 !== d3.value) && T(l3, "value", b3, d3.value, false), "checked" in _ && void 0 !== (b3 = _.checked) && b3 !== l3.checked && T(l3, "checked", b3, d3.checked, false));
  }
  return l3;
}
function O(n2, u3, t3) {
  try {
    "function" == typeof n2 ? n2(u3) : n2.current = u3;
  } catch (n3) {
    l.__e(n3, t3);
  }
}
function q(n2, u3, t3) {
  var i3, o3;
  if (l.unmount && l.unmount(n2), (i3 = n2.ref) && (i3.current && i3.current !== n2.__e || O(i3, null, u3)), null != (i3 = n2.__c)) {
    if (i3.componentWillUnmount)
      try {
        i3.componentWillUnmount();
      } catch (n3) {
        l.__e(n3, u3);
      }
    i3.base = i3.__P = null, n2.__c = void 0;
  }
  if (i3 = n2.__k)
    for (o3 = 0; o3 < i3.length; o3++)
      i3[o3] && q(i3[o3], u3, t3 || "function" != typeof n2.type);
  t3 || null == n2.__e || p(n2.__e), n2.__ = n2.__e = n2.__d = void 0;
}
function B(n2, l3, u3) {
  return this.constructor(n2, u3);
}
function D(u3, t3, i3) {
  var o3, r3, f3, e3;
  l.__ && l.__(u3, t3), r3 = (o3 = "function" == typeof i3) ? null : i3 && i3.__k || t3.__k, f3 = [], e3 = [], L(t3, u3 = (!o3 && i3 || t3).__k = y(k, null, [u3]), r3 || c, c, void 0 !== t3.ownerSVGElement, !o3 && i3 ? [i3] : r3 ? null : t3.firstChild ? n.call(t3.childNodes) : null, f3, !o3 && i3 ? i3 : r3 ? r3.__e : t3.firstChild, o3, e3), M(f3, u3, e3);
}
n = s.slice, l = { __e: function(n2, l3, u3, t3) {
  for (var i3, o3, r3; l3 = l3.__; )
    if ((i3 = l3.__c) && !i3.__)
      try {
        if ((o3 = i3.constructor) && null != o3.getDerivedStateFromError && (i3.setState(o3.getDerivedStateFromError(n2)), r3 = i3.__d), null != i3.componentDidCatch && (i3.componentDidCatch(n2, t3 || {}), r3 = i3.__d), r3)
          return i3.__E = i3;
      } catch (l4) {
        n2 = l4;
      }
  throw n2;
} }, u = 0, t = function(n2) {
  return null != n2 && void 0 === n2.constructor;
}, b.prototype.setState = function(n2, l3) {
  var u3;
  u3 = null != this.__s && this.__s !== this.state ? this.__s : this.__s = v({}, this.state), "function" == typeof n2 && (n2 = n2(v({}, u3), this.props)), n2 && v(u3, n2), null != n2 && this.__v && (l3 && this._sb.push(l3), w(this));
}, b.prototype.forceUpdate = function(n2) {
  this.__v && (this.__e = true, n2 && this.__h.push(n2), w(this));
}, b.prototype.render = k, i = [], r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, f = function(n2, l3) {
  return n2.__v.__b - l3.__v.__b;
}, x.__r = 0, e = 0;

// src/utils.ts
var PauseableTimeout = class {
  constructor(callback, ms) {
    this.callback = callback;
    this.ms = ms;
  }
  state = { t: "stopped" };
  runningMs = 0;
  start() {
    if (this.state.t === "stopped") {
      this.state = {
        t: "started",
        startedAt: Date.now(),
        stop: setupTimeout(() => {
          this.state = { t: "disposed" };
          this.callback();
        }, this.ms - this.runningMs)
      };
    }
  }
  stop() {
    if (this.state.t === "started") {
      this.state.stop();
      this.runningMs += Date.now() - this.state.startedAt;
      this.state = { t: "stopped" };
    }
  }
  dispose() {
    if (this.state.t === "started") {
      this.state.stop();
    }
    this.state = { t: "disposed" };
  }
};
function setupTimeout(f3, ms) {
  if (ms === Infinity) {
    return () => {
    };
  }
  let handle = setTimeout(f3, ms);
  return () => {
    clearTimeout(handle);
  };
}
function generateId() {
  return Math.floor(Math.random() * 2 ** 50).toString(32).padStart(10, "0");
}
function cls(...args) {
  return args.filter(Boolean).join(" ");
}
var styleAssign = Object.assign;

// src/core.ts
var TOAST_STEP = {
  START: 0,
  DISMISS: 1
};
var ToastManager = class {
  items = [];
  paused = false;
  create(data, { duration }) {
    const item = {
      id: generateId(),
      // TODO: support upsert by id?
      step: TOAST_STEP.START,
      duration,
      dismissTimeout: new PauseableTimeout(
        () => this.dismiss(item.id),
        duration
      ),
      data
    };
    if (!this.paused) {
      item.dismissTimeout.start();
    }
    this.items = [...this.items, item];
    this.notify();
  }
  update(id, newItem) {
    const index = this.items.findIndex((item) => item.id === id);
    if (index >= 0) {
      this.items = [...this.items];
      this.items[index] = { ...this.items[index], ...newItem };
      this.notify();
    }
  }
  dismiss(id) {
    this.update(id, { step: TOAST_STEP.DISMISS });
  }
  dismissAll() {
    for (const item of this.items) {
      this.dismiss(item.id);
    }
  }
  remove(id) {
    this.items = this.items.filter((item) => item.id !== id);
    this.notify();
  }
  removeAll() {
    this.items = [];
    this.notify();
  }
  pause(paused) {
    this.paused = paused;
    for (const item of this.items) {
      if (paused) {
        item.dismissTimeout.stop();
      } else {
        item.dismissTimeout.start();
      }
    }
    this.notify();
  }
  //
  // api for React.useSyncExternalStore
  //
  listeners = /* @__PURE__ */ new Set();
  snapshot = {};
  subscribe = (listener) => {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  };
  getSnapshot = () => this.snapshot;
  notify() {
    this.snapshot = {};
    this.listeners.forEach((f3) => f3());
  }
};

// ../tiny-transition/dist/index.js
function tinyassert(value, message) {
  if (value) {
    return;
  }
  if (message instanceof Error) {
    throw message;
  }
  throw new TinyAssertionError(message, tinyassert);
}
var TinyAssertionError = class _TinyAssertionError extends Error {
  constructor(message, stackStartFunction) {
    super(message);
    if ("captureStackTrace" in Error) {
      Error.captureStackTrace(this, stackStartFunction ?? _TinyAssertionError);
    }
  }
};
var TransitionManager = class {
  constructor(options) {
    this.options = options;
    this.state = this.options.defaultEntered ? "entered" : "left";
  }
  listeners = /* @__PURE__ */ new Set();
  disposables = /* @__PURE__ */ new Set();
  state = "left";
  el = null;
  shouldRender() {
    return this.state !== "left";
  }
  show(show) {
    if (show && this.state !== "entering" && this.state !== "entered") {
      this.state = "entering";
      this.startEnter();
      this.notify();
    }
    if (!show && this.state !== "leaving" && this.state !== "left") {
      this.state = "leaving";
      this.startLeave();
      this.notify();
    }
  }
  // api compatible with ref callback
  setElement = (el) => {
    this.dispose();
    this.el = el;
    if (!el)
      return;
    if (this.state === "entered") {
      this.options.onEntered?.(el);
    } else if (this.state === "entering") {
      this.startEnter();
    }
  };
  startEnter() {
    if (!this.el)
      return;
    const el = this.el;
    this.options.onEnterFrom?.(el);
    this.dispose();
    this.disposables.add(
      onNextFrame(() => {
        forceStyle(el);
        this.options.onEnterTo?.(el);
        this.disposables.add(
          onTransitionEnd(el, () => {
            this.state = "entered";
            this.notify(() => this.options.onEntered?.(el));
          })
        );
      })
    );
  }
  startLeave() {
    if (!this.el)
      return;
    const el = this.el;
    this.options.onLeaveFrom?.(el);
    this.dispose();
    this.disposables.add(
      onNextFrame(() => {
        forceStyle(el);
        this.options.onLeaveTo?.(el);
        this.disposables.add(
          onTransitionEnd(el, () => {
            this.state = "left";
            this.notify(() => this.options.onLeft?.(el));
          })
        );
      })
    );
  }
  dispose() {
    this.disposables.forEach((f3) => f3());
    this.disposables.clear();
  }
  //
  // api for React.useSyncExternalStore
  //
  subscribe = (listener) => {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  };
  getSnapshot = () => this.state;
  notify(callback) {
    if (this.listeners.size === 0)
      return;
    callback?.();
    this.listeners.forEach((f3) => f3());
  }
};
function onNextFrame(callback) {
  const id = requestAnimationFrame(callback);
  return () => {
    cancelAnimationFrame(id);
  };
}
function onTransitionEnd(el, callback) {
  const timeoutDuration = computeTransitionTimeout(el);
  const handle = setTimeout(() => callback(), timeoutDuration);
  return () => {
    clearTimeout(handle);
  };
}
function computeTransitionTimeout(el) {
  const style = getComputedStyle(el);
  const [duration, delay] = [
    style.transitionDuration,
    style.transitionDelay
  ].map((s3) => Math.max(...parseDuration(s3)));
  return duration + delay;
}
function parseDuration(s3) {
  return s3.trim().split(",").map((s22) => parseDurationSingle(s22.trim()));
}
function parseDurationSingle(s3) {
  let ms = 0;
  if (!s3) {
    ms = 0;
  } else if (s3.endsWith("ms")) {
    ms = Number.parseFloat(s3.slice(0, -2));
  } else if (s3.endsWith("s")) {
    ms = Number.parseFloat(s3.slice(0, -1)) * 1e3;
  }
  tinyassert(Number.isFinite(ms), `failed to parse css duration '${s3}'`);
  return ms;
}
function forceStyle(el) {
  typeof getComputedStyle(el).transition;
}

// ../../node_modules/.pnpm/@hiogawa+utils@1.6.1-pre.7/node_modules/@hiogawa/utils/dist/index.js
function tinyassert2(value, message) {
  if (value) {
    return;
  }
  if (message instanceof Error) {
    throw message;
  }
  throw new TinyAssertionError2(message, tinyassert2);
}
var TinyAssertionError2 = class _TinyAssertionError2 extends Error {
  constructor(message, stackStartFunction) {
    super(message);
    if ("captureStackTrace" in Error) {
      Error.captureStackTrace(this, stackStartFunction ?? _TinyAssertionError2);
    }
  }
};
function includesGuard(ls, v3) {
  return ls.includes(v3);
}
function groupBy(ls, f3) {
  const result = /* @__PURE__ */ new Map();
  for (const x2 of ls) {
    const y2 = f3(x2);
    if (!result.has(y2)) {
      result.set(y2, []);
    }
    result.get(y2).push(x2);
  }
  return result;
}

// ../../node_modules/.pnpm/preact@10.17.1/node_modules/preact/hooks/dist/hooks.mjs
var t2;
var r2;
var u2;
var i2;
var o2 = 0;
var f2 = [];
var c2 = [];
var e2 = l.__b;
var a2 = l.__r;
var v2 = l.diffed;
var l2 = l.__c;
var m2 = l.unmount;
function d2(t3, u3) {
  l.__h && l.__h(r2, t3, o2 || u3), o2 = 0;
  var i3 = r2.__H || (r2.__H = { __: [], __h: [] });
  return t3 >= i3.__.length && i3.__.push({ __V: c2 }), i3.__[t3];
}
function h2(n2) {
  return o2 = 1, s2(B2, n2);
}
function s2(n2, u3, i3) {
  var o3 = d2(t2++, 2);
  if (o3.t = n2, !o3.__c && (o3.__ = [i3 ? i3(u3) : B2(void 0, u3), function(n3) {
    var t3 = o3.__N ? o3.__N[0] : o3.__[0], r3 = o3.t(t3, n3);
    t3 !== r3 && (o3.__N = [r3, o3.__[1]], o3.__c.setState({}));
  }], o3.__c = r2, !r2.u)) {
    var f3 = function(n3, t3, r3) {
      if (!o3.__c.__H)
        return true;
      var u4 = o3.__c.__H.__.filter(function(n4) {
        return n4.__c;
      });
      if (u4.every(function(n4) {
        return !n4.__N;
      }))
        return !c3 || c3.call(this, n3, t3, r3);
      var i4 = false;
      return u4.forEach(function(n4) {
        if (n4.__N) {
          var t4 = n4.__[0];
          n4.__ = n4.__N, n4.__N = void 0, t4 !== n4.__[0] && (i4 = true);
        }
      }), !(!i4 && o3.__c.props === n3) && (!c3 || c3.call(this, n3, t3, r3));
    };
    r2.u = true;
    var c3 = r2.shouldComponentUpdate, e3 = r2.componentWillUpdate;
    r2.componentWillUpdate = function(n3, t3, r3) {
      if (this.__e) {
        var u4 = c3;
        c3 = void 0, f3(n3, t3, r3), c3 = u4;
      }
      e3 && e3.call(this, n3, t3, r3);
    }, r2.shouldComponentUpdate = f3;
  }
  return o3.__N || o3.__;
}
function p2(u3, i3) {
  var o3 = d2(t2++, 3);
  !l.__s && z2(o3.__H, i3) && (o3.__ = u3, o3.i = i3, r2.__H.__h.push(o3));
}
function b2() {
  for (var t3; t3 = f2.shift(); )
    if (t3.__P && t3.__H)
      try {
        t3.__H.__h.forEach(k2), t3.__H.__h.forEach(w2), t3.__H.__h = [];
      } catch (r3) {
        t3.__H.__h = [], l.__e(r3, t3.__v);
      }
}
l.__b = function(n2) {
  r2 = null, e2 && e2(n2);
}, l.__r = function(n2) {
  a2 && a2(n2), t2 = 0;
  var i3 = (r2 = n2.__c).__H;
  i3 && (u2 === r2 ? (i3.__h = [], r2.__h = [], i3.__.forEach(function(n3) {
    n3.__N && (n3.__ = n3.__N), n3.__V = c2, n3.__N = n3.i = void 0;
  })) : (i3.__h.forEach(k2), i3.__h.forEach(w2), i3.__h = [], t2 = 0)), u2 = r2;
}, l.diffed = function(t3) {
  v2 && v2(t3);
  var o3 = t3.__c;
  o3 && o3.__H && (o3.__H.__h.length && (1 !== f2.push(o3) && i2 === l.requestAnimationFrame || ((i2 = l.requestAnimationFrame) || j2)(b2)), o3.__H.__.forEach(function(n2) {
    n2.i && (n2.__H = n2.i), n2.__V !== c2 && (n2.__ = n2.__V), n2.i = void 0, n2.__V = c2;
  })), u2 = r2 = null;
}, l.__c = function(t3, r3) {
  r3.some(function(t4) {
    try {
      t4.__h.forEach(k2), t4.__h = t4.__h.filter(function(n2) {
        return !n2.__ || w2(n2);
      });
    } catch (u3) {
      r3.some(function(n2) {
        n2.__h && (n2.__h = []);
      }), r3 = [], l.__e(u3, t4.__v);
    }
  }), l2 && l2(t3, r3);
}, l.unmount = function(t3) {
  m2 && m2(t3);
  var r3, u3 = t3.__c;
  u3 && u3.__H && (u3.__H.__.forEach(function(n2) {
    try {
      k2(n2);
    } catch (n3) {
      r3 = n3;
    }
  }), u3.__H = void 0, r3 && l.__e(r3, u3.__v));
};
var g2 = "function" == typeof requestAnimationFrame;
function j2(n2) {
  var t3, r3 = function() {
    clearTimeout(u3), g2 && cancelAnimationFrame(t3), setTimeout(n2);
  }, u3 = setTimeout(r3, 100);
  g2 && (t3 = requestAnimationFrame(r3));
}
function k2(n2) {
  var t3 = r2, u3 = n2.__c;
  "function" == typeof u3 && (n2.__c = void 0, u3()), r2 = t3;
}
function w2(n2) {
  var t3 = r2;
  n2.__c = n2.__(), r2 = t3;
}
function z2(n2, t3) {
  return !n2 || n2.length !== t3.length || t3.some(function(t4, r3) {
    return t4 !== n2[r3];
  });
}
function B2(n2, t3) {
  return "function" == typeof t3 ? t3(n2) : t3;
}

// src/common.ts
var TOAST_TYPE_ICONS = {
  // https://remixicon.com/icon/checkbox-circle-fill
  success: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill="none" d="M0 0h24v24H0z"></path><path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z"></path></svg>`,
  // https://remixicon.com/icon/close-circle-fill
  error: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 10.5858L9.17157 7.75736L7.75736 9.17157L10.5858 12L7.75736 14.8284L9.17157 16.2426L12 13.4142L14.8284 16.2426L16.2426 14.8284L13.4142 12L16.2426 9.17157L14.8284 7.75736L12 10.5858Z"></path></svg>`,
  // https://remixicon.com/icon/information-fill
  info: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 11V17H13V11H11ZM11 7V9H13V7H11Z"></path></svg>`
};
var TOAST_TYPE_ICON_COLORS = {
  success: `#61d345`,
  error: `#ff4b4b`,
  info: `#1677ff`
};
function slideScaleCollapseTransition({
  position
}) {
  return {
    enterFrom: (el) => {
      tinyassert2(el.firstElementChild instanceof HTMLElement);
      styleAssign(el.style, {
        transition: "all 0.35s cubic-bezier(0, 0.8, 0.5, 1)",
        height: "0"
      });
      styleAssign(el.firstElementChild.style, {
        transition: "all 0.35s cubic-bezier(0, 0.8, 0.5, 1)",
        opacity: "0.5",
        transform: cls(
          "scale(0.5)",
          position === "bottom-left" && "translateY(200%)",
          position === "top-center" && "translateY(-200%)"
        )
      });
    },
    enterTo: (el) => {
      tinyassert2(el.firstElementChild instanceof HTMLElement);
      styleAssign(el.style, {
        height: el.firstElementChild.clientHeight + "px"
      });
      styleAssign(el.firstElementChild.style, {
        opacity: "1",
        transform: "scale(1) translateY(0)"
      });
    },
    entered: (el) => {
      tinyassert2(el.firstElementChild instanceof HTMLElement);
      styleAssign(el.style, {
        transition: "",
        height: ""
      });
      styleAssign(el.firstElementChild.style, {
        transition: ""
      });
    },
    leaveFrom: (el) => {
      tinyassert2(el.firstElementChild instanceof HTMLElement);
      styleAssign(el.style, {
        transition: "all 0.25s ease",
        height: el.firstElementChild.clientHeight + "px"
      });
      styleAssign(el.firstElementChild.style, {
        transition: "all 0.25s ease",
        opacity: "1",
        transform: "scale(1) translateY(0)"
      });
    },
    leaveTo: (el) => {
      tinyassert2(el.firstElementChild instanceof HTMLElement);
      styleAssign(el.style, {
        height: "0"
      });
      styleAssign(el.firstElementChild.style, {
        opacity: "0",
        transform: cls(
          "scale(0)",
          position === "bottom-left" && "translateY(150%)",
          position === "top-center" && "translateY(-150%)"
        )
      });
    }
  };
}

// src/preact/ui.tsx
function ToastContainer({ toast }) {
  useSubscribe(toast.subscribe);
  const itemsByPosition = groupBy(toast.items, (item) => item.data.position);
  return y(
    "div",
    {
      style: istyle({
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        pointerEvents: "none"
      }),
      onMouseEnter: () => {
        toast.pause(true);
      },
      onMouseLeave: () => {
        toast.pause(false);
      }
    },
    [
      y(
        "div",
        {
          style: istyle({
            position: "absolute",
            bottom: "0.5rem",
            left: "0.75rem",
            display: "flex",
            flexDirection: "column"
          })
        },
        itemsByPosition.get("bottom-left")?.map((item) => y(ToastAnimation, { key: item.id, toast, item }))
      ),
      y(
        "div",
        {
          style: istyle({
            position: "absolute",
            top: "0.5rem",
            width: "100%",
            display: "flex",
            flexDirection: "column-reverse",
            alignItems: "center"
          })
        },
        itemsByPosition.get("top-center")?.map((item) => y(ToastAnimation, { key: item.id, toast, item }))
      )
    ]
  );
}
function ToastAnimation({
  toast,
  item
}) {
  const [manager] = h2(() => {
    const transition = slideScaleCollapseTransition({
      position: item.data.position
    });
    const manager2 = new TransitionManager({
      defaultEntered: false,
      onEnterFrom: transition.enterFrom,
      onEnterTo: transition.enterTo,
      onEntered: transition.entered,
      onLeaveFrom: transition.leaveFrom,
      onLeaveTo: transition.leaveTo,
      onLeft: () => toast.remove(item.id)
    });
    return manager2;
  });
  useSubscribe(manager.subscribe);
  p2(() => {
    manager.show(item.step < TOAST_STEP.DISMISS);
  }, [item.step]);
  if (!manager.shouldRender()) {
    return null;
  }
  return y(
    "div",
    {
      ref: manager.setElement,
      style: istyle({
        pointerEvents: "auto"
      })
    },
    y(
      "div",
      { style: istyle({ display: "inline-block", padding: "0.25rem 0" }) },
      y(ToastItemComponent, { toast, item })
    )
  );
}
function ToastItemComponent({
  toast,
  item
}) {
  return y(
    "div",
    {
      class: item.data.class,
      style: istyle({
        display: "flex",
        alignItems: "center",
        padding: "10px 10px",
        borderRadius: "8px",
        boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)"
      }) + (item.data.style ?? "")
    },
    includesGuard(["success", "error", "info"], item.data.type) && y("span", {
      style: istyle({
        width: "1.5rem",
        height: "1.5rem",
        color: TOAST_TYPE_ICON_COLORS[item.data.type]
      }),
      dangerouslySetInnerHTML: {
        __html: TOAST_TYPE_ICONS[item.data.type]
      }
    }),
    y(
      "div",
      { style: istyle({ padding: "0 10px" }) },
      item.data.render({ h: y, toast, item })
    )
  );
}
function useSubscribe(subscribe) {
  const rerender = s2((prev) => !prev, false)[1];
  p2(() => {
    return subscribe(() => rerender());
  }, [subscribe]);
}
function istyle(props) {
  return Object.entries(props).map(([k3, v3]) => `${k3.replace(/[A-Z]/g, "-$&").toLowerCase()}:${v3};`).join("");
}

// src/preact/api.tsx
var PreactToastManager = class extends ToastManager {
  defaultOptions = {
    position: "top-center",
    duration: 4e3
  };
  render() {
    const el = document.createElement("div");
    el.setAttribute("data-tiny-toast", "");
    document.body.appendChild(el);
    D(y(ToastContainer, { toast: this }), el);
    return () => {
      D(null, el);
      el.remove();
    };
  }
  success = createByTypeFactory("success");
  error = createByTypeFactory("error");
  info = createByTypeFactory("info");
  custom = createByTypeFactory("custom");
};
function createByTypeFactory(type) {
  return function(render, options) {
    this.create(
      {
        render: typeof render === "function" ? render : () => render,
        type,
        position: options?.position ?? this.defaultOptions.position,
        class: options?.class ?? this.defaultOptions.class,
        style: options?.style ?? this.defaultOptions.style
      },
      {
        duration: options?.duration ?? this.defaultOptions.duration / (type === "success" ? 2 : 1)
      }
    );
  };
}
export {
  PreactToastManager
};
